<!-- =========================================================================================
    File Name: Customers.vue
    Description: Tabs - Imports all Customers portions
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div id="customers">
        <div class="mt-5">
            <vs-tabs alignment="center" :color="tabColor">
                <vs-tab label="Customers" icon-pack="feather" icon="icon-package" @click="tabColor = 'green'" >
                    <customers-list></customers-list>
                </vs-tab>
                <vs-tab label="Delivery Details" icon-pack="feather" icon="icon-home" @click="tabColor = 'red'" >
                    <delivery-list></delivery-list>
                </vs-tab>
            </vs-tabs>
        </div>
    </div>
</template>

<script>

import CustomersList from './customers/CustomersList.vue'
import DeliveryList from './delivery/DeliveryList.vue'

export default{
    components: {
        CustomersList,
        DeliveryList
    },
    data() {
        return {
            tabColor: 'green'
        }
    },
}
</script>